import { useTranslation } from 'react-i18next';

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  const { t } = useTranslation('common');
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <p className="text-sm text-[var(--color-text-secondary)] mb-3">Something went wrong loading this screen.</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className="text-[var(--color-primary-500)] font-semibold">{t('retry')}</button>
      ) : null}
    </div>
  );
}
